import _defineProperty from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["anchor", "checkboxItems", "closeOption", "elevation", "leftDivider", "rightDivider", "sliderText", "titleText", "triggerComponent"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Close } from '@mui/icons-material';
import { Popper, Grid, Fade, Typography, Card, CardHeader, IconButton, CardContent, Slider } from '@mui/material';
import React from 'react';
import { ASPENDENTAL_FONTS } from '../../../constants/constant';
import DrawerItems from './DrawerItems';

var TAGDrawer = function TAGDrawer(_ref) {
  var anchor = _ref.anchor,
      checkboxItems = _ref.checkboxItems,
      closeOption = _ref.closeOption,
      elevation = _ref.elevation,
      leftDivider = _ref.leftDivider,
      rightDivider = _ref.rightDivider,
      sliderText = _ref.sliderText,
      titleText = _ref.titleText,
      triggerComponent = _ref.triggerComponent,
      props = _objectWithoutProperties(_ref, _excluded);

  var _React$useState = React.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      anchorEl = _React$useState2[0],
      setAnchorEl = _React$useState2[1];

  var _React$useState3 = React.useState(false),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      open = _React$useState4[0],
      setOpen = _React$useState4[1];

  var _React$useState5 = React.useState(),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      placement = _React$useState6[0],
      setPlacement = _React$useState6[1];

  var handleClick = function handleClick(drawerPlacement) {
    return function (event) {
      setAnchorEl(event.currentTarget);
      setOpen(!open);
      setPlacement(drawerPlacement);
    };
  };

  var closePopper = function closePopper() {
    setOpen(false);
  }; //this function allows the user to pass in whatever they want as the component that will open the popper


  var TriggerDivWrapper = function TriggerDivWrapper() {
    return React.createElement('div', _objectSpread({
      style: {
        cursor: 'pointer',
        width: 'fit-content',
        height: 'fit-content'
      },
      onClick: handleClick(anchor),
      'data-test': 'testingDiv'
    }, props), triggerComponent);
  };

  return React.createElement(Grid, {
    container: true,
    sx: {
      justifyContent: 'center'
    }
  }, TriggerDivWrapper(), React.createElement(Popper, {
    open: open,
    anchorEl: anchorEl,
    placement: placement,
    transition: true
  }, function (_ref2) {
    var TransitionProps = _ref2.TransitionProps;
    return React.createElement(Fade, _objectSpread(_objectSpread({}, TransitionProps), {}, {
      timeout: 350
    }), React.createElement(Card, {
      elevation: elevation && !rightDivider && !leftDivider ? 9 : 0,
      sx: {
        borderLeft: leftDivider && !rightDivider && !elevation ? '1px solid' : 'none',
        borderRight: rightDivider && !leftDivider && !elevation ? '1px solid' : 'none',
        borderLeftColor: leftDivider && !rightDivider && !elevation ? 'neutrals.primary' : 'none',
        borderRightColor: rightDivider && !leftDivider && !elevation ? 'neutrals.primary' : 'none',
        borderRadius: 0,
        width: '320px'
      }
    }, React.createElement(CardHeader, {
      title: titleText,
      titleTypographyProps: ASPENDENTAL_FONTS.bodyLargeBold,
      action: closeOption && React.createElement(IconButton, {
        onClick: function onClick() {
          return closePopper();
        },
        "aria-label": "settings"
      }, React.createElement(Close, null))
    }), React.createElement(CardContent, null, React.createElement(Typography, {
      sx: ASPENDENTAL_FONTS.bodyMediumBook
    }, "Labels"), React.createElement(DrawerItems, {
      checkboxItems: checkboxItems
    }), React.createElement(Typography, {
      sx: [ASPENDENTAL_FONTS.bodyMediumBook, {
        marginTop: '28px'
      }]
    }, sliderText), React.createElement(Slider, {
      size: "small",
      defaultValue: 30,
      valueLabelDisplay: "auto"
    }))));
  }));
};

export default TAGDrawer;